<div class="claims-wrapper">
  <div class="claims-header" (click)="redirectToHomePage()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Network Hospitals
  </div>

  <div class="claims-body">
    <iframe src="https://integration.brobotinsurance.com/Geo_Locator/locator/corporate_network_hospital_list"
      frameborder="0" width="100%" height="100%"
      allow="geolocation"
      onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px';"></iframe>
  </div>
</div>

<!-- <div class="start-tarack-claim-wrapper" >
  <div class="button-text">Download Policy Benefits</div>
</div> -->